import React from 'react'
import ItemPerformanceShowtimes from './ItemPerformanceShowtimes';
import ReactScrollLink from '../General/ReactScollLink'
import getTranslation from '../functions/getTranslation';
import Translation from '../General/Translation';
import getTranslationTime from '../functions/getTranslationTime';
import getMomentNow from '../functions/getMomentNow';
import getDayKey from '../functions/getDayKey';
import getPerformancesIntervall from '../functions/getPerformancesIntervall';
import setMomentDateObjZero from '../functions/setMomentDateObjZero';
import getFullyFilteredPerformances from '../functions/getFullyFilteredPerformances';

const ItemPerformances = ({
    movieId, 
    filterType, 
    stripeAppearance, 
    filterValue, 
    itemData, 
    performances, 
    activeCinema, 
    additionalClass, 
    theme,
    movieIndex,
    dayFilters,
    queryStringValues,
    overviewFilterIgnoreOnPerformances,
    translation, 
    onClick, 
    scrollToPosition, 
    isOverview, 
    isMobile, 
    showMobileMovieTimes, 
    onOpenPerformancePage, 
    currentBrowserWidth
}) => {
    const { timezone } = translation
    const moreButtonText = isOverview ? getTranslation('more', translation).toUpperCase() : getTranslation('moreDays', translation)
    const dateNow = getMomentNow(timezone)
    const keyToday = getDayKey(dateNow)
    const today = setMomentDateObjZero(getMomentNow(timezone))
    //TESTING COUNTDOWN!!!
    // const today = setMomentDateObjZero(getMomentDateObj(1711120780000, timezone)) 
    const { title, startingDate, limitations, alternativeLinks, technologyAttributes } = itemData    
    const {visibleFrom, showCountdown} = limitations
    const formatedDate =  visibleFrom ? getTranslationTime('performanceDates', translation, visibleFrom) : startingDate ? getTranslationTime('performanceDates', translation, startingDate) : null
    let edgeFixedPerformancesDates
    const {fullyfilteredPerformance} = getFullyFilteredPerformances(performances, activeCinema, technologyAttributes, queryStringValues, filterType, filterValue, overviewFilterIgnoreOnPerformances, dayFilters)
    const periodesDays = getPerformancesIntervall(fullyfilteredPerformance, today, timezone)
    
    const noEmptyDays = _.omit(periodesDays, function(value, key, object) {
        return _.isEmpty(value);
    });
    
    const noEmptyDaysKeys = _.keys(noEmptyDays)
    const performancesLength = noEmptyDaysKeys.length
    
    const getSlices = () => {
        if(stripeAppearance === 'no_slide' || (theme === 'Arthouse' && isMobile)) {
            return 1
        } else if(performancesLength > 4) { 
            if(currentBrowserWidth > 775) {
                return 3
            } else if(currentBrowserWidth > 500) {
                return 2
            } else {
                return 1
            }
        } else if(performancesLength === 4) {
            if(currentBrowserWidth > 775) {
                return 
            } else if(currentBrowserWidth > 500) {
                return 2
            } else {
                return 1
            }
        } else if(performancesLength === 3) {
            if(currentBrowserWidth > 500) {
                return 3
            } else {
                return 1
            }
        } else if(performancesLength <= 2) {
            return performancesLength
        } else {
            return 1
        }
    }
    const performancesSlice = noEmptyDaysKeys.slice(0, getSlices())

    const performanceDates = () => {
        if (stripeAppearance === 'no_slide') {
            return performancesSlice.map((keyDay, index) => {
                const currentDayFormarted = keyToday === keyDay ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, keyDay)
                
                return (
                    <div className="performance-item-wrapper" key={index}>
                        <div className="performance-item-date text-medium">{currentDayFormarted}</div>
                        <ItemPerformanceShowtimes 
                            movieTitle={title}
                            movieId={movieId}
                            onClick={onClick} 
                            keyDay={keyDay}
                            alternativeLinks={alternativeLinks}
                            noEmptyDaysKeys={noEmptyDaysKeys}
                            movieIndex={movieIndex}
                            dateNow={dateNow}
                            performances={noEmptyDays[keyDay]} 
                            stripeAppearance={stripeAppearance}
                            translation={translation}
                            scrollToPosition={scrollToPosition}
                            isMobile={isMobile}
                            onOpenPerformancePage={onOpenPerformancePage}
                            />
                    </div>
                )
            })
        } else if(isOverview) {
            if(showMobileMovieTimes === false) {
                const performanceDate = performancesSlice.map((keyDay, index) => {
                    const currentDayFormarted = keyToday === keyDay ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, keyDay) 
                    
                    return (
                        <div key={index} className="performance-item-dates is-overview">
                            <ReactScrollLink className="performance-item-dates" to={scrollToPosition + ' openMovieInformation'} smooth={true} offset={-200}>
                                <div className="performance-item-wrapper">
                                    <button onClick={() => onClick(keyDay)} className={"performance-item-date theme-radius-posters-full text-light cursor-pointer" + additionalClass}>{currentDayFormarted}</button>
                                </div>
                            </ReactScrollLink>  
                        </div>
                    )
                })
                return performanceDate
            } else {
                return (
                    <div className="performance-item-dates is-overview">
                        <ReactScrollLink className="performance-item-dates" to={scrollToPosition + ' movieInformation'} smooth={false} offset={-200}>
                            <div className="performance-item-wrapper">
                                <button onClick={() => onClick()} className={"performance-item-date theme-radius-posters-full text-light cursor-pointer" + additionalClass}>{getTranslation('less', translation).toUpperCase()}</button>
                            </div>
                        </ReactScrollLink>
                    </div>
                )
            }
        } else {
            const performanceDate = performancesSlice.map((keyDay, index) => {
                const currentDayFormarted = keyToday === keyDay ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, keyDay) 
                const onlyOneDayActiveClass = (queryStringValues && queryStringValues.time && (queryStringValues.time === 'today' || queryStringValues.time === 'tomorrow')) ? ' one-day' : ''
                return (
                    <div className={"performance-item-wrapper" + onlyOneDayActiveClass} key={index}>
                        {!(queryStringValues && queryStringValues.time && (queryStringValues.time === 'today' || queryStringValues.time === 'tomorrow')) && <div className="performance-item-date text-medium">{currentDayFormarted}</div>}
                        <ItemPerformanceShowtimes 
                            movieTitle={title}
                            movieId={movieId}
                            onClick={onClick} 
                            keyDay={keyDay}
                            movieIndex={movieIndex}
                            theme={theme}
                            alternativeLinks={alternativeLinks}
                            dateNow={dateNow}
                            noEmptyDaysKeys={noEmptyDaysKeys}
                            performances={noEmptyDays[keyDay]} 
                            translation={translation}
                            scrollToPosition={scrollToPosition}
                            isMobile={isMobile}
                            onOpenPerformancePage={onOpenPerformancePage}
                        />
                    </div>
                )
            })

            return performanceDate
        }
    }

    edgeFixedPerformancesDates = performanceDates()

    if(performanceDates()[1]) {
        if(performanceDates()[1].props.children === "Heute") {
        // if(performanceDates()[1].props.children.props.children.props.children.props.children === "Heute") {
            edgeFixedPerformancesDates = performanceDates().reverse()
        }
    }

    const performanceItems = () => {
        if(performancesLength <= 2 || showMobileMovieTimes || stripeAppearance === 'no_slide') {
            return (
                <div className="performance-item-dates-wrapper">
                    {edgeFixedPerformancesDates}
                </div>
            )
        } else {
            return (
                <div className="performance-item-dates-wrapper">
                    {edgeFixedPerformancesDates}
                    <ReactScrollLink className="performance-item-dates" to={scrollToPosition + ' openMovieInformation'} smooth={true} offset={isOverview ? -200 : 300}>
                        <button className="performance-item-more-dates theme-radius-posters-full text-medium cursor-pointer" onClick={() => onClick()}>
                            {moreButtonText}
                        </button>
                    </ReactScrollLink>
                </div>
            )
        }
    }

    if(fullyfilteredPerformance[0]) {
        return (
            <div className="performance-items-wrapper theme-radius-posters-bottom">
                {performanceItems()}
            </div>
        )
    } else {
        return (
            <div className="performance-items-wrapper theme-radius-posters-bottom">            
                {((showCountdown && visibleFrom) || (!showCountdown && !visibleFrom) || formatedDate) ? (
                    <span className="preview-text">{getTranslation('availableFrom', translation).toLowerCase()} {formatedDate}</span>
                ) : (
                    <span className="preview-text">{getTranslation('comingSoon', translation).toLowerCase()}</span>
                )}
            </div>
        )
    }
}

export default ItemPerformances